import { notEmpty, type Optional } from '@festina-life/core'

import { MetaTypes } from '../../types/metaModel'
import {
  type SimpleTemplateField,
  type SimpleValueSetupFieldValue,
  ValueSetupRole,
} from '../../types/templateModel'

const circularReferenceKeys = ['versionInfo', 'subTemplatedField']

const isCircularRef = (key: string, value: unknown) =>
  typeof value === 'object' &&
  !!value &&
  (circularReferenceKeys.includes(key) ||
    ('_type' in value && value._type === MetaTypes.ModelMetaType))

/** List of keys to be excluded while comparing value setups. **/
export const defaultExcludeKeys = [
  'availableVariantTypes',
  'fields',
  'versionInfo',
  'origin',
  'path',
  'isParentNotRelevant',
]
/**
 * Custom stringify function that removes version infos from objects. This is used for diffing
 * purposes where version infos are expected to always differ.
 */
export const stringifyComparableValue = (
  value: unknown,
  excludeKeys: string[] = defaultExcludeKeys,
) =>
  JSON.stringify(value ?? undefined, (key, keyValue) => {
    if (
      isCircularRef(key, keyValue) ||
      excludeKeys.includes(key) ||
      (Array.isArray(keyValue) && !keyValue.filter(notEmpty).length)
    ) {
      return undefined
    }

    return typeof keyValue === 'string' && !keyValue
      ? undefined
      : (keyValue ?? undefined)
  }) ?? ''

export const isSimpleValueSetupFieldValue = (
  value: SimpleTemplateField['value'],
): value is Optional<SimpleValueSetupFieldValue> =>
  !value || ('role' in value && value.role === ValueSetupRole.SIMPLE)
